<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12>
        <h2 class="title">Alterar e-mail</h2>
      </v-flex>
    </v-layout>
    <v-form v-model="valid" ref="form">
      <v-layout row wrap form-padding mt-4>
        <v-flex xs4>
          <v-text-field
            placeholder=" "
            class="form-input-box"
            :label="'CPF'"
            v-mask="'###.###.###-##'"
            :disabled="true"
            :value="documento_pessoa"
          />
        </v-flex>
        <v-flex xs4>
          <v-text-field
            placeholder=" "
            :disabled="true"
            class="form-input-box"
            label="Nome"
            :value="nome_pessoa"
          />
        </v-flex>
        <v-flex xs4>
          <v-text-field
            placeholder=" "
            class="form-input-box"
            label="E-mail"
            :rules="[
              (v) => !!v || 'Campo obrigatório',
              (v) =>
                /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
                'E-mail tem que ser válido',
              (v) =>
                !temEmailRepetido(v) ||
                'E-mail já utilizado por ' + pessoa_nome,
            ]"
            v-model="emailPessoa"
            autofocus
          />
        </v-flex>
      </v-layout>
    </v-form>
    <v-layout row wrap>
      <v-flex xs2 offset-xs8>
        <button class="button jns-button blue-button mt-5" @click="close()">
          Cancelar
        </button>
      </v-flex>
      <v-flex xs2>
        <button class="button jns-button yellow-button mt-5" @click="save()">
          Salvar
        </button>
      </v-flex>
    </v-layout>
  </div>
</template>

<script lang="js">
import ViewMixin from "@/mixins/ViewMixin";

export default {
  name: "TomadorCCGAlterarPessoaModal",
  mixins: [ViewMixin],
  props: [
    "idTomador",
    "id_pessoa",
    "documento_pessoa",
    "nome_pessoa",
    "email_pessoa",
    "tipo_pessoa",
    "categoria",
  ],
  data: () => ({
    valid: false,
    pessoa_email: "",
    pessoa_nome: "",
  }),
  computed: {
    tipoPessoaInserir() {
      if (!this.tipo_pessoa) {
        return "Representante";
      }
      return this.tipo_pessoa == "FISICA"
        ? "Cônjuge"
        : this.tipo_pessoa == "JURIDICA"
        ? "Representante"
        : "Pessoa";
    },
    emailPessoa: {
      get: function () {
        return this.email_pessoa;
      },
      set: function (newValue) {
        this.pessoa_email = newValue;
      },
    },
  },
  methods: {
    async save() {
      let response;

      if (!this.valid) return;

      this.showLoadingAskWait();

      if (this.id_pessoa > 0) {
        try {
          response = await this.$store.dispatch("UPDATE_CCG_EMAIL", {
            pessoa: {
              id_pessoa: this.id_pessoa,
              email: this.pessoa_email,
            },
            idTomador: this.idTomador,
          });
        } catch (e) {
          this.defaultHandlerError(e);
          this.$emit("error");
          return;
        } finally {
          this.hideLoadingAskWait();
        }
      }
      this.$emit("save", { tipoPessoaInserir: this.tipoPessoaInserir });
      this.close();
    },

    close() {
      //this.pessoa = []
      this.$emit("close");
      this.pessoa_email = "";
    },

    temEmailRepetido(email) {
      let temEmailRepetido = false;
      if (this.categoria == "Fiador")
        this.$store.state.ccg.ccg.fiadores.forEach((item) => {
          if (item.tipo_pessoa != "JURIDICA") {
            if (
              item.email == email &&
              this.documento_pessoa != item.documento
            ) {
              temEmailRepetido = true;
              this.pessoa_nome = item.nome;
            }
          } else {
            item.representantes.forEach((representante) => {
              if (
                representante.email == email &&
                this.documento_pessoa != representante.documento
              ) {
                temEmailRepetido = true;
                this.pessoa_nome = representante.nome;
              } else if (
                representante.conjuge &&
                representante.conjuge.email == email &&
                this.documento_pessoa != representante.conjuge.documento
              ) {
                temEmailRepetido = true;
                this.pessoa_nome = representante.conjuge.nome;
              }
            });
          }
        });
      else
        this.$store.state.ccg.ccg.representantes_legais.forEach((item) => {
          if (item.email == email && this.documento_pessoa != item.documento) {
            temEmailRepetido = true;
            this.pessoa_nome = item.nome;
          } else if (
            item.conjuge &&
            item.conjuge.email == email &&
            this.documento_pessoa != item.conjuge.documento
          ) {
            temEmailRepetido = true;
            this.pessoa_nome = item.conjuge.nome;
          }
        });
      if (temEmailRepetido) this.$forceUpdate();

      return temEmailRepetido;
    },
  },
};
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// ./src/components/TomadorCCGAlterarPessoaModal.vue